import { createMessageEnum, MessageKey } from '@mi-front/core';
import { defineMessages } from 'react-intl';

/**
 * Message descriptors for auth error codes. Used with formatMessage/$t to show localized messages.
 */
export const authErrorMessages = defineMessages({
  ERR_USER_NOT_REGISTERED: {
    id: 'auth.errors.ERR_USER_NOT_REGISTERED',
    defaultMessage: 'El usuario no está registrado en la plataforma, por favor contacta a soporte.',
  },
  ERR_AUTH_FAILED: {
    id: 'auth.errors.ERR_AUTH_FAILED',
    defaultMessage: 'Por favor intenta nuevamente o contacta a soporte.',
  },
});

/** Auth error code type derived from authErrorMessages keys. */
export type AuthErrorCode = MessageKey<typeof authErrorMessages>;

/**
 * Enum-like object of auth error codes for use as variables (e.g. when comparing or passing error codes).
 */
export const AuthErrors = createMessageEnum(authErrorMessages);
